import React from 'react';
import {useAgenticSuggestions} from './use-agentic-suggestions';
import type {ActionEvent} from 'src/components/agentic-ui/types';
import {DefaultMessagePartView} from './default-message-view';
import {CircularLoader} from '@spaced-out/ui-design-system';
import css from './agentic-suggestions.css';


export function AgenticSuggestions({
  publishMessageAction,
}: {
  publishMessageAction: (action: ActionEvent) => void;
}) {
  const chat = useAgenticSuggestions({
    runKey: 'agentic-suggestion-renderer',
  });

  //NOTE:(diwaker) only one assistant message is allowed for start screen
  const assistantMessage = chat.snapshot.messages.find(
    (message) => message.role === 'assistant',
  );

  if (!assistantMessage) {
    return (
      <div className={css.container}>
        <CircularLoader className={css.circularLoader} />
      </div>
    );
  }
  const flattenedParts = assistantMessage.parts.map((part) => ({
    ...part,
    messageId: assistantMessage.id,
    messageRole: assistantMessage.role,
    showAssistantAnchor: false,
    isLastPartInMessage: true,
  }));

  return (
    <div className={css.container}>
      {flattenedParts.map((part, idx) => (
        <DefaultMessagePartView
          showAssistantAnchor={false}
          key={part.id ?? idx}
          part={part}
          role="assistant"
          showChatBubble={true}
          publishMessageAction={publishMessageAction}
          showFeedback={false}
        />
      ))}
    </div>
  );
}
